import React, { useContext, useState, useEffect } from 'react';
import EDList from '../../../../../../../../../BaseComponents/List/EDList';
import EkonomiskAnalysExpandableNestedListItem from '../ListItems/EkonomiskAnalysExpandableNestedListItem';
import EkonomiskAnalysUrval from './Components/Urval/EkonomiskAnalysUrval';
import EkonomiskAnalysSummering from './Components/Summering/EkonomiskAnalysSummering';
import EDDivider from '../../../../../../../../../BaseComponents/Divider/EDDivider';
import { EkonomiskAnalysSideMenuContext } from '../../Context/EkonomiskAnalysSideMenuContext';
import EkonomiskAnalysSimpleUrvalSuggestionContext from './Components/Urval/SimpleUrval/EkonomiskAnalysSimpleUrvalSuggestionContext';
import { ISumData } from '../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { getSumsInfo } from '../../../../../../../../../Components/Urval/Utils/urvalUtils';
import { AvenyCollectionMap } from '../../../../../../../../../Model/ModelContext/ModelContext';
import { EkonomiskAnalysContext } from '../../../Context/EkonomiskAnalysContext';

interface IProps {
  summeringChanged: boolean;
  urvalChanged: boolean;
  isLopandeAnalys?: boolean;
  sideMenuOpen: boolean;
  collectionMap: AvenyCollectionMap;
  updateReport: (updateOrig?: boolean) => void;
}

/**
 * Det ufällda innehållet i UrvalSummering fliken av sidomeny med inställningar för urval och summering.
 */
const EkonomiskAnalysUrvalSummering: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    newAnalysSettings,
    setUrval,
    selectedAnalys,
    codeSystemId,
    onSumsChanged,
  } = useContext(EkonomiskAnalysSideMenuContext);
  const { kodbehorighetsUrval } = useContext(EkonomiskAnalysContext);

  const [urvalOpen, setUrvalOpen] = useState(true);
  const [summeringOpen, setSummeringOpen] = useState(false);

  useEffect(() => {
    setUrvalOpen(true);
    setSummeringOpen(false);
  }, [props.sideMenuOpen, selectedAnalys]);

  const sumsChanged = (newSums: ISumData[]) => {
    const sumsInfo = getSumsInfo(
      newSums,
      props.collectionMap,
      newAnalysSettings.sums,
      newAnalysSettings.urval || undefined
    );

    onSumsChanged(newSums, sumsInfo.urval);
  };

  return (
    <>
      <EDList disableVerticalPadding>
        <EkonomiskAnalysExpandableNestedListItem
          open={summeringOpen && Boolean(props.isLopandeAnalys)}
          setOpen={setSummeringOpen}
          text="Summering"
          iconType="sigma"
          changed={props.summeringChanged}
          disabled={!props.isLopandeAnalys}
          disabledReason={
            !props.isLopandeAnalys
              ? 'Summeringsbegrepp ej tillgängliga för radbaserad analys'
              : undefined
          }
        >
          <EkonomiskAnalysSummering
            changed={props.summeringChanged}
            onSumsChanged={sumsChanged}
          />
        </EkonomiskAnalysExpandableNestedListItem>
        <EDDivider />
        <EkonomiskAnalysExpandableNestedListItem
          open={urvalOpen}
          setOpen={setUrvalOpen}
          text="Urval"
          iconType="filter_list"
          changed={props.urvalChanged}
          rightSideIcon
        >
          <EkonomiskAnalysSimpleUrvalSuggestionContext
            urval={newAnalysSettings.urval}
          >
            {(kontodelarValues, kontobegreppValues) => (
              <EkonomiskAnalysUrval
                urval={newAnalysSettings.urval}
                kontodelarValues={kontodelarValues}
                kontobegreppValues={kontobegreppValues}
                setUrval={setUrval}
                codePrivilege={
                  selectedAnalys ? selectedAnalys.codePrivilege : null
                }
                codeSystemId={codeSystemId}
                kodbehorighetsUrval={kodbehorighetsUrval}
                updateReport={props.updateReport}
                autoFocus={true}
              />
            )}
          </EkonomiskAnalysSimpleUrvalSuggestionContext>
        </EkonomiskAnalysExpandableNestedListItem>
      </EDList>
    </>
  );
};

export default EkonomiskAnalysUrvalSummering;
